export default "__VITE_ASSET__DHvCcHme__"